import React from "react";
import theme from "styles/theme";
import { merge } from "glamor";

const isMobileViewport = window.matchMedia("(max-width: 750px)");

const styles = {
    colorBanner: {
        position: "absolute",
        display: "block",
        left: "0px",
        right: "0px",
        zIndex: 2,
        textAlign: "center",
        bottom: isMobileViewport.matches ? "50px" : "0px",
        fontSize: "14px",
        lineHeight: "20px",
        padding: "16px 10px",
        color: theme.palette.darkGrey,
        backgroundColor: "rgba(255, 255, 255, .9)",
        cursor: "pointer",
        textTransform: "uppercase",
        margin: "0px",
        transition: "all .2s ease-in-out",
        pointerEvents: "none",
    },
    colorBannerHover: {
        bottom: "50px",
    },
};

export default function ColorBanner({ item, hover = false, inActiveList = false, inOrder = false }) {
    if (item && item.__colorBanner) {
        return (
            <div {...merge(styles.colorBanner, (hover || inActiveList || inOrder) && styles.colorBannerHover)}>
                {item.__colorBanner}
            </div>
        );
    }
    return null;
}
